export default __webpack_public_path__ + "static/media/assets_liabilities_02_es.cd55b132.png";